module.exports = __webpack_public_path__ + "static/rotation-2e34ff62233c1939d5d8ca952db1f131.png";